import { Box, BoxContent } from '@mm/components';
import moment from 'moment';
import React, { useState } from 'react';
import { NeedHelpLabel } from '../../../../common/components/NeedHelpLabel/NeedHelpLabel';
import { AnalyticsFilterByDate } from './AnalyticsFilterByTime/AnalyticsFilterByDate';
import './BotAnalytics.scss';
import { ContactsByChart } from './sectionsComponents/ContactsByChart/ContactsByChart';
import { ContactsConversationsChart } from './sectionsComponents/ContactsConversationsChart/ContactsConversationsChart';
import { KeywordsTriggered } from './sectionsComponents/KeywordsTriggered/KeywordsTriggered';
import { TopDialogues } from './sectionsComponents/TopDialogues';

export const BotAnalytics = () => {
  const [startDate, setStartDate] = useState<moment.Moment | null>(
    moment().subtract(14, 'days'),
  );
  const [endDate, setEndDate] = useState<moment.Moment | null>(moment());
  const [dateRangeMode, setDateRangeMode] = useState<string | null>(
    'Last 14 days',
  );

  return (
    <div className="bot-analytics__wrapper">
      <div className="bot-analytics__header">
        Bot Analytics
        <div className="bot-analytics__calendar-container">
          View by date
          <AnalyticsFilterByDate
            className="bot-analytics__calendar"
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            dateRangeMode={dateRangeMode}
            setDateRangeMode={setDateRangeMode}
          />
          <NeedHelpLabel
            iconOnly={true}
            link="https://customers.ai/help/article/beo6r98ja4-analytics"
          />
        </div>
      </div>
      <section className="bot-analytics">
        <Box className="bot-analytics__box">
          <BoxContent className="bot-analytics__sections">
            <ContactsConversationsChart
              startDate={startDate}
              endDate={endDate}
              dateRangeMode={dateRangeMode}
            />
            <ContactsByChart
              startDate={startDate}
              endDate={endDate}
              dateRangeMode={dateRangeMode}
            />
            <TopDialogues
              startDate={startDate}
              endDate={endDate}
              dateRangeMode={dateRangeMode}
            />
            <KeywordsTriggered
              mode="unansweredQuestions"
              startDate={startDate}
              endDate={endDate}
              dateRangeMode={dateRangeMode}
            />
            <KeywordsTriggered
              mode="qaKeywords"
              startDate={startDate}
              endDate={endDate}
              dateRangeMode={dateRangeMode}
            />
          </BoxContent>
        </Box>
      </section>
    </div>
  );
};
